<template>
  <div
    v-if="showBadge && isMounted"
    class="pzo-badge"
    :class="{
      'margin-bottom-xs padding-xxs': !isProductPerksEnabled,
      'margin-bottom-xxs padding-xs pzo-perk': isProductPerksEnabled,
    }"
  >
    <template v-if="isProductPerksEnabled">
      <span class="personalized-offers-dark-medium icon margin-right-xxs"></span>
      <div class="medium">Eligible for exclusive offer in Bag</div>
    </template>
    <template v-else> Exclusive offer: Find your discount in bag </template>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useMounted } from '@vueuse/core';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import usePzo from '../composables/usePzo';

const { showBadge, checkPzo } = usePzo();
const isMounted = useMounted();
const { isProductPerksEnabled } = useFeatureEligibility();
const pzoContentAvailable = computed(() => showBadge.value && isMounted.value);
onMounted(async () => {
  await checkPzo();
});

defineExpose({
  pzoContentAvailable,
});
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
@import '~@csgIcons/new/personalized-offers-dark-medium';

.pzo-badge {
  background-color: #f6d96a; // Custom color for pzo badge
  max-width: rem-calc(298);

  @include breakpoint(small only) {
    max-width: 100%;
  }
}
.pzo-perk {
  max-width: 100%;
  display: flex;
  align-items: center;
  border-radius: rem-calc(5);
}
.icon {
  min-width: rem-calc(24);
  display: flex;
}
</style>
